module.exports = __webpack_public_path__ + "static/media/handshake.3afbe7e7.svg";